<template>
  <!-- 存款按鈕 -->
  <div class="bank-promo-n form-submit-frame">
    <button
      class="button-style-w100 btn-primary"
      :disabled="isButtonDisable"
      @click="$emit('submit')"
    >
      <template v-if="isBuyCrypto">
        <span>{{ $t('Bao.submit') }}</span>
      </template>
      <template v-else>
        <span>
          {{ $t('Bao.deposit') }}
          {{ displayAmount }}
        </span>
      </template>
    </button>

    <a
      v-if="showDepositGuide && !isBuyCrypto"
      class="help-deposit-n"
      @click="$router.push('/page/support')"
    >
      <span class="icon-help">?</span>
      <span class="help-text">{{ $t('Bao.deposit_guide') }}</span>
    </a>
  </div>
</template>

<script>
export default {
  name: 'DepositSendBtn',
  props: {
    typeCode: {
      type: String,
      default: ''
    },
    amount: {
      type: [String, Number],
      default: 0
    },
    currency: {
      type: String,
      default: ''
    },
    isButtonDisable: {
      type: Boolean,
      default: false
    },
    isBuyCrypto: {
      type: Boolean,
      default: false
    },
    showDepositGuide: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    displayAmount() {
      const filters = this.$options.filters
      return this.typeCode === 'CCPAY_INVOICE'
        ? filters.numberFormatFull(this.amount)
        : filters.numberFormat(this.amount)
    }
  }
}
</script>
